<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Externe Dienstleister"
        @save="saveExternalProvidersFormData">
        <b-row>
            <csp-desktop-info-card-element class="col-6" :form-context="formContext" label="Logistiker"
               :options-loader="loadLogisticianOptions" property="logistician" type="autocomplete"/>
            <csp-desktop-info-card-element class="col-6" :form-context="formContext" label="KARO-Lack"
               :options-loader="loadPaintShopOptions" property="paintShop" type="autocomplete"/>
            <csp-desktop-info-card-element class="col-6" :form-context="formContext" label="Aufbereiter"
               :options-loader="loadDetailerOptions" property="detailer" type="autocomplete"/>
        </b-row>
        <div class="float-right">
            <b-button :href="getQrLink()" variant="primary">
                <i class="inticon-autoclaim_einzeldownload_blue"/> QR Code Dienstleisterdokumentation
            </b-button>
        </div>
        <div class="clear-float"/>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '../../mixins/FormDataMixin';

    const container = Container.getInstance();

    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'ParticipantExternal',
        mixins: [FormDataMixin],
        data() {
            return {
            };
        },
        computed: {
            recordId() {
                return this.$route.params.recordId;
            },
            permissions() {
                return this.formContext.permissions;
            },
        },
        methods: {
            loadDetailerOptions() {
                return recordRepository.loadDetailerOptions(this.recordId);
            },
            loadLogisticianOptions() {
                return recordRepository.loadLogisticianOptions(this.recordId);
            },
            loadPaintShopOptions() {
                return recordRepository.loadPaintShopOptions(this.recordId);
            },
            saveExternalProvidersFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveParticipantsExternal(this.recordId, postData)
                }
                this.saveFormData(formContext, saveFunction, null);
            },
            getQrLink() {
                return `/api/records/${this.$route.params.recordId}/qr-image-external-service-doc/png`;
            },
        },
    }
</script>
